import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class HeroPlugin extends Plugin {

    init() {

        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
              trigger: this.el,
              start: "top",
              end: "20% top",
              scrub: 1,
            }
        });
        
        tl.to('.hero-widget__more', { opacity: 0 });

    }

}